import { Helmet } from "react-helmet-async";

const SITE_URL = "https://www.padlr.co";
const DEFAULT_IMAGE = "https://customer-assets-7cd3h4nn.emergentagent.net/job_padel-shop-4/artifacts/nldlxshe_espresso-front.png";

export default function SEO({
  title,
  description,
  path = "/",
  image,
  type = "website",
  product,
}) {
  const fullTitle = title
    ? `${title} | Padlr. — Premium Padel Clothing`
    : "Padlr. | Premium Padel Clothing & Lifestyle Brand | Born in Switzerland";
  const desc =
    description ||
    "Padlr. is a premium padel clothing brand born in Switzerland. Performance t-shirts, shorts & caps for the court and the street. Better Than Yesterday. | Premium Padel Bekleidung aus der Schweiz.";
  const url = `${SITE_URL}${path}`;
  const img = image || DEFAULT_IMAGE;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />

      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={img} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />

      {product && (
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Product",
            name: product.name,
            description: product.description,
            image: product.image,
            url: url,
            brand: { "@type": "Brand", name: "Padlr." },
            offers: {
              "@type": "Offer",
              price: product.price,
              priceCurrency: "CHF",
              availability: "https://schema.org/PreOrder",
              seller: { "@type": "Organization", name: "Padlr." },
            },
            category: "Padel Clothing",
            material: "Technical Performance Fabric",
            countryOfOrigin: { "@type": "Country", name: "Switzerland" },
          })}
        </script>
      )}
    </Helmet>
  );
}
